import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92c08098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "title fw-light" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_4 = ["href"]

import { onMounted, ref } from 'vue'
import CoachingSessionQuestion from '@/components/CoachingSessionQuestion'
import { ConfigurationAsPromise } from '@/config/config'
import { useSessionRegistryStore } from '../SessionRegistryStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleBar',
  props: {
  isLsat: {
    type: Boolean,
    default: false
  },
  askQuestionUrl: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const needHelpUrl = ref<string>('')
const { sessionState } = useSessionRegistryStore()



onMounted(async () => {
  needHelpUrl.value = (await ConfigurationAsPromise).NEED_HELP_URL ?? ''
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(sessionState).isLSAT ? 'PowerScore Classroom Central' : 'My BARBRI Connect'), 1),
    (!__props.isLsat)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("a", {
            href: needHelpUrl.value,
            class: "me-3 need-help"
          }, " Need help? ", 8, _hoisted_4),
          _createVNode(_unref(CoachingSessionQuestion), { href: __props.askQuestionUrl }, null, 8, ["href"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})